import PropTypes from "prop-types";
import React from "react";
import { Controller, useController } from "react-hook-form";
// import classNames from 'classnames';

const Toggle = ({
  name,
  value,
  message,
  control,
  register,
  className,
  classNameswitch,
  label,
  absolute,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: register,
    defaultValue: value,
  });
  return (
    <div>
      {label ? <label className="input__label">{label} :</label> : null}
      <label
        className={`switch relative inline-block ${classNameswitch}`}
      >
        <input type="checkbox" {...field} {...rest} />
        <span
          className={`slider bg-white border-[1px] border-purple border-solid round ${className} before:absolute before:content-[''] before:w-[2.6rem] before:h-[2.6rem] before:left-[0.2rem] before:bottom-[0.2rem]`}
        ></span>
      </label>
      {error && <span className="input__message">{error.message}</span>}
    </div>
  );
};

Toggle.propTypes = {
  classes: PropTypes.any,
  control: PropTypes.any,
  errors: PropTypes.any,
  label: PropTypes.string,
  message: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.any,
  value: PropTypes.any,
};
export default Toggle;
